export default __webpack_public_path__ + "static/media/tierfreunde_12.30224280.jpg";